<template>
  <modal
    v-slot="{ data }"
    name="select-table-top-device-order-modal"
    modal-style="compact"
  >
    <select-table-top-device-order
      :open-orders="data.orders"
      v-on="{ 'callback-handler': !!data.callbackHandler ? data.callbackHandler: () => {} }"
    />
  </modal>
</template>


<script>
  import SelectTableTopDeviceOrder from './select-table-top-device-order/index.vue';


  export default {
    name: 'SelectTableTopDeviceOrderModal',

    components: {
      SelectTableTopDeviceOrder
    }
  };
</script>
